<div class="flex h-full w-full flex-col rounded-lg py-5">
  <!-- Type filters -->
  <div class="mb-4 flex flex-col">
    <!-- Filter buttons -->
    <div class="flex flex-wrap gap-2">
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-blue-primary bg-blue-primary text-white': selectedTypeFilter() === 'All',
          'text-gray-700 border-gray-300 hover:border-gray-400 bg-white': selectedTypeFilter() !== 'All',
        }"
        (click)="setTypeFilter('All')"
      >
        Всі
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-blue-primary bg-blue-primary text-white': selectedTypeFilter() === 'Appointment',
          'text-gray-700 border-gray-300 hover:border-gray-400 bg-white': selectedTypeFilter() !== 'Appointment',
        }"
        (click)="setTypeFilter('Appointment')"
      >
        Консультації
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-blue-primary bg-blue-primary text-white': selectedTypeFilter() === 'Drugs',
          'text-gray-700 border-gray-300 hover:border-gray-400 bg-white': selectedTypeFilter() !== 'Drugs',
        }"
        (click)="setTypeFilter('Drugs')"
      >
        Ліки
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-blue-primary bg-blue-primary text-white': selectedTypeFilter() === 'InstrumentalDiagnostic',
          'text-gray-700 border-gray-300 hover:border-gray-400 bg-white': selectedTypeFilter() !== 'InstrumentalDiagnostic',
        }"
        (click)="setTypeFilter('InstrumentalDiagnostic')"
      >
        Діагностика
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-blue-primary bg-blue-primary text-white': selectedTypeFilter() === 'LaboratoryService',
          'text-gray-700 border-gray-300 hover:border-gray-400 bg-white': selectedTypeFilter() !== 'LaboratoryService',
        }"
        (click)="setTypeFilter('LaboratoryService')"
      >
        Лабораторні послуги
      </button>
    </div>
  </div>

  <!-- Prescriptions list -->
  <div class="flex-1 overflow-y-auto overflow-x-hidden">
    @if (loading()) {
      <div class="flex h-32 items-center justify-center">
        <shared-loading></shared-loading>
      </div>
    } @else {
      @if (filteredPrescriptions().length > 0) {
        @for (prescription of filteredPrescriptions(); track prescription.id) {
          <div
            class="border-gray-200 mb-4 cursor-pointer rounded-lg border p-4 transition-shadow hover:shadow-md"
            [ngClass]="{ 'border-2 border-blue-primary bg-warning-100': highlightedPrescriptionId() === prescription.id }"
            [attr.data-prescription-id]="prescription.id"
          >
            <div class="flex items-start gap-3">
              <mat-icon
                class="mt-1 text-blue-primary"
                [fontIcon]="getPrescriptionIcon(prescription.prescriptionType)"
              >
              </mat-icon>
              <div class="flex-1">
                <div class="flex flex-col gap-1">
                  <div class="flex items-start justify-between">
                    <h5 class="text-sm font-medium">{{ prescription.prescriptionName }}</h5>
                    <button
                      class="bg-gray-100 hover:bg-gray-200 flex !h-6 !w-6 items-center justify-center rounded-full shadow-sm"
                      [matMenuTriggerFor]="prescriptionActionsMenu"
                      (click)="$event.stopPropagation()"
                      type="button"
                    >
                      <mat-icon
                        class="text-gray-600 text-sm"
                        [fontIcon]="'more_vert'"
                      ></mat-icon>
                    </button>
                    <mat-menu #prescriptionActionsMenu="matMenu">
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="createAppointment(prescription, $event)"
                      >
                        <mat-icon [fontIcon]="'event'"></mat-icon>
                        {{ "Створити візит" }}
                      </button>
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="bindToExistingAppointment(prescription, $event)"
                      >
                        <mat-icon [fontIcon]="'link'"></mat-icon>
                        {{ "Прив'язати до існуючого" }}
                      </button>
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="navigateToPrescription(prescription, $event)"
                      >
                        <mat-icon [fontIcon]="'open_in_new'"></mat-icon>
                        {{ "Переглянути в гарантації" }}
                      </button>
                    </mat-menu>
                  </div>
                  <p class="text-gray-600 text-xs">
                    {{ "medicalServices.prescriptionTypes." + prescription.prescriptionType | translate }}
                  </p>
                  <div class="mt-2 flex items-center gap-2">
                    <shared-status
                      [statusValue]="prescription.guaranteeStatus"
                      [statusMessage]="'statuses.guarantationStatuses.' + prescription.guaranteeStatus | translate"
                    ></shared-status>
                    <mat-icon class="text-gray-400 text-sm">keyboard_double_arrow_right</mat-icon>
                    <shared-status
                      [statusValue]="prescription.prescriptionPlanningStatus"
                      [statusMessage]="'status.prescription.planning.' + prescription.prescriptionPlanningStatus | translate"
                    ></shared-status>
                  </div>
                  @if (prescription.prescriptionCreationDate) {
                    <p class="text-gray-500 mt-1 text-xs">Створено: {{ formatDate(prescription.prescriptionCreationDate, true) }}</p>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="text-gray-500 py-8 text-center">
          <p>Немає призначень</p>
        </div>
      }
    }
  </div>
</div>
